import hashnodeImage from '../images/hashnode.png'
import '../styles/blog.scss'
import Flip from 'react-reveal/Flip'
import { useSelector } from 'react-redux'
import { readMyBlog } from '../constants/constants'

const Blog = () => {

    //Setting up a hook on current language
    const storeCurrentLanguage = state => state.language;
    const currentLanguage = useSelector(storeCurrentLanguage);

    return (
        <a className = "blog" href = "https://clementbenezech.hashnode.dev/">
        <div className = "blog__title">{readMyBlog[currentLanguage]} </div>
        <Flip right><img className = "blog__image" src = {hashnodeImage} alt = "Logo Blog Hashnode"></img></Flip>
        </a>
    )
        
}
export default Blog